var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{attrs:{"id":"sub"}},[_c('div',{staticClass:"subnav-txt col-4-3"},[_c('h1',[_vm._v(_vm._s(_vm.routeTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.routeHeading))])])]),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }